import React from "react";
import ReactDOM from "react-dom";
import FolderNodeModel from "../../models/FolderNodeModel";
import PropertyPanelWidget from "../PropertyPanelWidget";
import Utility from "../../utilities/Utility";

export default class NewFolderEmbed extends React.Component {
    /**
     * Embedded popup inside dialog for adding blank element
     * @module NewFolderEmbed
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.initTempNode();
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount(){
        const panel = $('#newFolderEmbedPropertyPanel');
        ReactDOM.render(<PropertyPanelWidget 
            panelDOM={panel}
            context={this.tempNode} 
            embed={true}/>, panel.get(0));
    }

    initTempNode(){

            this.tempNode = new FolderNodeModel();

    }

    handleClose(){
        ReactDOM.unmountComponentAtNode($('#newFolderEmbedPropertyPanel')[0]);
    }

    /**
     * Convert data model to serialized format
     * @returns {Object}
     */
    compile(){

            return {
                "id": Utility.uuid4(),
                "name": this.tempNode.getConfig("name"),
                "type": "folder",
                "props": {
                     "folderType": this.props.type
            },
                "children" : []
            };
        }
    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className={"col-md-12"}>
                            <label>{"Create A New " + window.l.popup[this.props.type] + " Folder"}</label>
                        </div>
                        <div id={"newFolderEmbedPropertyPanel"} className="col-md-12">
                            {/* property panel renders here */}
                        </div>
                    </div>
                </div>
                <div className={"element-buttons"}>
                    <button className={"w2ui-btn secondary"} onClick={() => {
                        w2popup.message();
                        this.handleClose();
                    }}>{window.l.popup.close}
                    </button>
                    <button className={"w2ui-btn primary"} onClick={() => {
                        if (!this.tempNode.hasError()) {
                            this.props.addFunc($('#tl_container'), this.compile(),false, null,this.props.coOrdinates);
                            this.props.changeProps(this.props.type);
                            w2popup.message();
                            this.handleClose();
                        } else {
                            alert(window.l.popup.fix_error);
                        }
                    }}>{window.l.popup.add}
                    </button>
                </div>
            </div>
        );
    }
}